module.exports = __webpack_public_path__ + "img/54.9f12a821.jpg";